import { render } from "./CheckboxField.vue?vue&type=template&id=78ba3cad"
import script from "./CheckboxField.vue?vue&type=script&lang=ts"
export * from "./CheckboxField.vue?vue&type=script&lang=ts"
script.render = render

export default script